import logo200Image from 'assets/img/logo/logo_200.png';
import React from 'react';

import { Navbar, Nav, NavItem } from 'reactstrap';

import SourceLink from 'components/SourceLink';

const Footer = () => {
  return (
    <Navbar>
      <Nav navbar>
        <NavItem>
			{global.config.copyright}{' '}
			<a href="https://renobuilding.ca" >Reno Building Canada Inc.</a>{' '}         
          {global.config.version}{' '}
        </NavItem>
      </Nav>
    </Navbar>
  );
};

export default Footer;
